export const getIsTranslationAvailable = (
  reviewLanguage: string,
  languageCode: string
) => {
  return !languageCode.startsWith(reviewLanguage)
}
